function constantSelectDirective() {
	return {
		scope : {
			constant : '@',
			value : '=',
			constantValues : '@?', // si se requiere algunos valores de las
			// constantes y no todos ej:
			// SAMPLE_STATE.valuesTask()
			constantSelected : '=?values',
			onConstantChange : '&',
			disabledControl : '=?',
			requiredModel : '@required',
			limitMultiple : '@?limit',
			placeholderDir : '@?placeholder'
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/constantSelectDirective.html';
		},
		controller : [ '$scope', '$window', function($scope, $window) {

			$scope.valueWasChangedFromSelector = false;
			$scope.limit = 1;
			$scope.constantItems = [];
			$scope.constantSelected = {
				selected : $scope.value
			};
			$scope.placeholder = "";
			$scope.required = false;

			if ($scope.requiredModel || $scope.requiredModel === "") {
				if ($scope.requiredModel != "false")
					$scope.required = true;
			}

			if ($scope.placeholderDir) {
				$scope.placeholder = $scope.placeholderDir;
			}

			if ($scope.limitMultiple) {
				if (!isNaN(Number($scope.limitMultiple))) {
					$scope.limit = $scope.limitMultiple;
				}
			}

			if (angular.isUndefined($scope.required)) {
				$scope.required = false;
			}

			if ($scope.disabledControl == undefined) {
				$scope.disabledControl = false;
			}

			$scope.loadConstants = function() {
				if ($scope.constantValues) {
					$scope.constantItems = eval($scope.constantValues);
				} else {
					var constantName = eval($scope.constant);
					$scope.constantItems = getValuesOrderByName(constantName);
				}
				$scope.selectedValue = $scope.constantItems[0];
			};

			$scope.constantChanged = function(constant) {
				$scope.valueWasChangedFromSelector = true;
				if (!angular.isUndefined($scope.value))
					$scope.value = constant;
				if ($scope.onConstantChange != undefined) {
					$scope.onConstantChange({
						constantSelected : constant
					});
				}
			};

			$scope.$watch('value', function(newValue, oldValue) {
				if ($scope.valueWasChangedFromSelector == false) {
					if (newValue == undefined) {
						$scope.constantSelected = {
							selected : null
						};
					} else {
						$scope.constantSelected = {
							selected : newValue
						};
					}

				}
				$scope.valueWasChangedFromSelector = false;
			});

		} ],
		link : function(scope, elem, attr) {
			scope.loadConstants();
		}
	};
};

module.directive('constantSelect', [ constantSelectDirective ]);